import Modal, { ModalHeader, ModalBody, ModalFooter } from '../../../../../../modal/Modal';
import Button from '../../../../../../primitives/form/button/Button';
import TextareaField from '../../../../../../primitives/form/TextareaField/TextareaField';

function UpdateConfirmation(props) {
  const { showModal, changeReasonValue, handleChangeReason, closeModal, handleSave, showLoadingIcon } = props;

  return (
    <Modal showModal={showModal} modalSize="small">
      <ModalHeader>
        <h1 className="modal__small-title">Confirm Action</h1>
        <h2 className="modal__large-title">Update Message</h2>
      </ModalHeader>
      <ModalBody>
        <div className="form__group-wrapper form__group-wrapper">
          <div className="form form__group">
            <TextareaField
              fieldID="reason_for_change"
              fieldIdentifier="reason-for-change"
              fieldName="Describe your update"
              fieldRequired={false}
              value={changeReasonValue}
              handleChange={(event) => {
                handleChangeReason(event);
              }}
              disabled={false}
              autoComplete="off"
            />
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="form modal__footer--forms">
          <div className="cta__group cta__group--form">
            <Button
              name="SAVE"
              actionType="button"
              disable={!(changeReasonValue && !showLoadingIcon)}
              buttonType="primary"
              loadingIcon={showLoadingIcon}
              handleClick={(e) => {
                handleSave();
              }}
              dataTestId="update-confirmation-save-button"
            />
            <Button
              name="CANCEL"
              actionType="button"
              disable={false}
              buttonType="light"
              handleClick={(e) => {
                closeModal();
              }}
              dataTestId="update-confirmation-cancel-button"
            />
          </div>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default UpdateConfirmation;
